var setExpire = function (time) {
  var date = new Date(time)
  var newDate = new Date(date.setDate(date.getDate() + 7))
  return 'expires=' + newDate.toUTCString()
}

var getDomain = function () {
  var domain = window.location.hostname
  return 'domain=' + domain
}

export const setCookie = function (cookieName, value) {
  var cookie = `${cookieName}=${value}`
  var expire = setExpire(Date.now())
  var domain = getDomain()
  var path = 'path=/'
  document.cookie = [cookie, expire, domain, path].join('; ')
}

export const checkCookie = function (cookieName) {
  if (
    document.cookie.split(';').filter(function (item) {
      return item.indexOf(cookieName) >= 0
    }).length
  ) {
    return true
  }
}
